export default [
  {
    path: "/school-list",
    component: (resolve) => require(["@/vuepage/school-manage/list.vue"], resolve),
    meta: [
      {
        name: "分校管理",
      },
      {
        name: "分校列表",
        activeRoute: "/school-list",
      },
    ],
  },
  {
    path: "/school-add",
    component: (resolve) => require(["@/vuepage/school-manage/add.vue"], resolve),
    meta: [
      {
        name: "分校管理",
      },
      {
        name: "新增分校",
        activeRoute: "/school-list",
      },
    ],
  },
];
